// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__QiTeB","active":"styles_active__Eb3vf","link":"styles_link__ak6pf"};